<template>
  <div>
    <div class="banner">
      <div class="content">
        <div class="banner-title">品牌商城定制</div>
        <div class="line" />
        <div class="desc">
          搭建属于自有品牌的商城系统，摆脱第三方商城平台限制，沉淀自有流量池
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="block-br01">
      <div class="sk-block-title">
        <div class="title">全终端覆盖</div>
      </div>
      <div class="content-01">
        <div class="item-01">
          <div class="tip" />
          <img src="@/assets/images/solution/brand-pic-01.png" alt="">
          <div class="name">PC端商城</div>
        </div>
        <div class="item-01">
          <div class="tip" />
          <img src="@/assets/images/solution/brand-pic-02.png" alt="">
          <div class="name">APP商城</div>
        </div>
        <div class="item-01">
          <div class="tip" />
          <img src="@/assets/images/solution/brand-pic-03.png" alt="">
          <div class="name">H5/公众号商城</div>
        </div>
        <div class="item-01">
          <div class="tip" />
          <img src="@/assets/images/solution/brand-pic-04.png" alt="">
          <div class="name">小程序商城</div>
        </div>
      </div>
    </div>
    <div class="block-br02">
      <div class="sk-block-title">
        <div class="title">多种电商模式支持</div>
      </div>
      <div class="content-02">
        <img src="@/assets/images/solution/brand-ad-01.png" alt="">
      </div>
    </div>
    <div class="block-br01">
      <div class="sk-block-title">
        <div class="title">产品特点</div>
      </div>
      <div class="content-03">
        <div class="item-03">
          <div class="name">活动组件</div>
          <div class="line" />
          <div>提供多种促销活动组件，帮助企业营销更多样有趣</div>
          <img src="@/assets/images/solution/brand-pic1-01.png" alt="">
        </div>
        <div class="item-03">
          <div class="name">精准营销</div>
          <div class="line" />
          <div>通过对会员数据分析，为顾客提供精准推荐，实现千人千面</div>
          <img src="@/assets/images/solution/brand-pic1-02.png" alt="">
        </div>
        <div class="item-03">
          <div class="name">会员权益</div>
          <div class="line" />
          <div>登陆有礼、购物返利、积分商城、积分抵现等多种会员权益玩法，帮助企业更好流程顾客</div>
          <img src="@/assets/images/solution/brand-pic1-03.png" alt="">
        </div>
        <div class="item-03">
          <div class="name">商城DIY</div>
          <div class="line" />
          <div>商城界面轻松个性定制，传递企业自己的品牌和思想</div>
          <img src="@/assets/images/solution/brand-pic1-04.png" alt="">
        </div>
      </div>
    </div>
    <div class="block-br02">
      <div class="sk-block-title">
        <div class="title">商城后台功能</div>
      </div>
      <div class="content-04">
        <div v-for="(item, index) in functionList" :key="`functionList_0${index+1}`" class="item-04">
          <img class="icon" :src="require(`@/assets/images/solution/brand-icon-0${index+1}.png`)" alt="">
          <div>{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="block-br03">
      <div class="sk-block-title">
        <div class="title">丰富的营销玩法</div>
      </div>
      <div class="content-05">
        <div class="tab">
          <div v-for="(item, index) in tabList" :key="`tabList_0${index+1}`" :class="['tab-item', {'tab-ac': index === tabActive}]" @click="changeTab(index)">{{ item }}</div>
        </div>
        <div v-show="tabActive === 0" class="tab-con">
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-01.png" alt="">
            <div class="name">小猫钓鱼</div>
          </div>
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-02.png" alt="">
            <div class="name">幸运大转盘</div>
          </div>
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-03.png" alt="">
            <div class="name">欢乐摇奖机</div>
          </div>
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-04.png" alt="">
            <div class="name">套圈圈</div>
          </div>
        </div>
        <div v-show="tabActive === 1" class="tab-con">
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-05.png" alt="">
            <div class="name">积分</div>
          </div>
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-06.png" alt="">
            <div class="name">优惠券</div>
          </div>
        </div>
        <div v-show="tabActive === 2" class="tab-con">
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-07.png" alt="">
            <div class="name">直降活动</div>
          </div>
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-08.png" alt="">
            <div class="name">秒杀活动</div>
          </div>
          <div class="tab-con-item">
            <img src="@/assets/images/solution/brand-pic2-09.png" alt="">
            <div class="name">拼团活动</div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-br01">
      <div class="sk-block-title">
        <div class="title">定制流程</div>
      </div>
      <div class="content-06">
        <img src="@/assets/images/solution/brand-ad-02.png" alt="">
      </div>
    </div>
    <CarouselItem title="品牌商城定制" />
    <ConsultForm info-sources="品牌商城定制" title="我要定制" />
    <TryModal v-if="visible" :visible="visible" info-sources="品牌商城定制" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.BrandCustom,
  name: 'BrandCustom',
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      functionList: ['商品管理', '订单管理', '促销管理', '会员管理', '短信营销', '积分系统', ' 在线支付', '商城装修'],
      tabList: ['互动小游戏', '会员权益', '营销活动'],
      tabActive: 0,
      visible: false
    }
  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    },
    changeTab(index) {
      this.tabActive = index
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  background: url("~@/assets/images/solution/brand-banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #28DAFB;
      margin: 16px 0 31px;
    }
    .desc {
      width: 484px;
      height: 101px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
    }
    .btn-wrap {
      .btn {
        width: 200px;
        height: 58px;
        line-height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
      }
    }
  }
}
.block-br01 {
  background: #fff;
}
.block-br02 {
  background: #F8FBFF;
}
.block-br03 {
  background: url('~@/assets/images/solution/brand-bg-01.png') no-repeat 0 0;
  width: 100%;
  .sk-block-title {
    .title {
      color: #fff;
    }
  }
}
.content-01 {
  width: 1200px;
  margin: 0 auto;
  padding: 48px 0 60px;
  display: flex;
  justify-content: space-between;
  .item-01 {
    border: 1px solid #DDDDDD;
    width: 279px;
    color: #595961;
    font-size: 20px;
    text-align: center;
    position: relative;
    font-weight: 500;
    .tip {
      position: absolute;
      left: 15px;
      bottom: 84px;
      width: 72px;
      height: 72px;
      overflow: hidden;
      border-radius: 50%;
      background: url('~@/assets/images/solution/brand-icon1-01.png') no-repeat 0 0;
    }
    .name {
      margin: 55px 0 37px;
    }
    &:nth-child(2) {
      .tip {
        background-image: url('~@/assets/images/solution/brand-icon1-02.png');
      }
    }
    &:nth-child(3) {
      .tip {
        background-image: url('~@/assets/images/solution/brand-icon1-03.png');
      }
    }
    &:nth-child(4) {
      .tip {
        background-image: url('~@/assets/images/solution/brand-icon1-04.png');
      }
    }
  }
}
.content-02 {
  width: 1200px;
  margin: 0 auto;
  padding: 58px 0 75px;
  text-align: center;
}
.content-03 {
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0;
  display: flex;
  justify-content: space-between;
  .item-03 {
    width: 276px;
    height: 356px;
    background: #F8FBFF;
    padding: 30px 20px 0;
    color: #8B8FA1;
    font-size: 16px;
    overflow: hidden;
    .line {
      width: 28px;
      height: 3px;
      background: #3986FF;
      margin: 14px auto;
    }
    .name {
      color: #3986FF;
      font-size: 20px;
      font-weight: bold;
    }
    &:nth-child(1) .line{
      background: #47BB93;
    }
    &:nth-child(3) {
      .line {
        background: #FF9F00;
      }
      >img {
        margin-top: -18px;
      }
    }
  }
}
.content-04 {
  width: 1200px;
  margin: 0 auto;
  padding-top: 70px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .item-04 {
    width: 176px;
    text-align: center;
    color: #595961;
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 60px;
    margin-right: 98px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.content-05 {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 53px;
  .tab {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.51);
    display: flex;
    justify-content: space-around;
    &-item {
      width: 248px;
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      padding-bottom: 22px;
      text-align: center;
      border-bottom: none;
      &:hover {
        cursor: pointer;
      }
    }
    .tab-ac {
      border-bottom: 4px solid #fff;
    }
    &-con {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-top: 39px;
      &-item {
        width: 217px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        .name {
          margin-top: 20px;
        }
      }
    }
  }
}
.content-06 {
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0 63px;
}
</style>
